<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2021-12-08 11:07:01
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\views\layout\layout.vue
-->
<template>
  <div class="cart_index">
    <top />
    <header-info />
    <router-view/>
    <footer-info />
    <right-aside fromPages="cart" />
  </div>
</template>

<script>
import HeaderInfo from '@/components/cart/cartHeader.vue';
import top from '@/components/pageComponents/top.vue';
import FooterInfo from '@/components/pageComponents/footer.vue'
import RightAside from '../../components/pageComponents/rightAside.vue';

export default {
  components: { top, HeaderInfo,FooterInfo,RightAside },
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>
<style>
.cart_index{
    background-color: #FFFFFF;
    position: relative;
}
</style>


// WEBPACK FOOTER //
// src/views/cart/index.vue